/*
 * TP-G Farm - Reviews carousel enhancement.
 * -------------------------------------------------------------------------
 * Progressive enhancement only. The cards are server-rendered inside a
 * horizontal scroll-snap viewport, so on touch they already swipe and the
 * content is fully readable with no JavaScript. This file just:
 *   - reveals the prev/next buttons and wires them to scrollBy (page step),
 *   - keeps their disabled state and an aria-live status region in sync,
 *   - hides the controls when there is nothing to scroll at the current width,
 *   - honors prefers-reduced-motion,
 *   - re-inits/cleans up on Shopify section load/unload without double-binding.
 * Scoped to .tpg-rev; no globals leak beyond a single init guard.
 */
(function () {
  'use strict';

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setup(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.dataset.revReady === '1') return;

    var carousel = root.querySelector('.rev-carousel');
    var vp = root.querySelector('.rev-viewport');
    var track = root.querySelector('.rev-track');
    if (!carousel || !vp || !track) return;

    var prev = root.querySelector('.rev-prev');
    var next = root.querySelector('.rev-next');
    var status = root.querySelector('.rev-status');
    var slides = track.children;

    root.dataset.revReady = '1';
    carousel.classList.add('is-ready');
    if (prev) prev.hidden = false;
    if (next) next.hidden = false;

    function maxScroll() {
      return Math.max(0, vp.scrollWidth - vp.clientWidth);
    }
    function scrollable() {
      return maxScroll() > 2;
    }

    function visibleRange() {
      // Returns [firstIndex, lastIndex] (1-based) of slides intersecting the viewport.
      var vpRect = vp.getBoundingClientRect();
      var first = 0, last = 0;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect();
        if (r.right > vpRect.left + 2 && r.left < vpRect.right - 2) {
          if (first === 0) first = i + 1;
          last = i + 1;
        }
      }
      if (first === 0) { first = 1; last = 1; }
      return [first, last];
    }

    function update() {
      var can = scrollable();
      carousel.classList.toggle('has-nav', can);
      if (prev) prev.hidden = !can;
      if (next) next.hidden = !can;

      if (!can) {
        if (status) status.textContent = '';
        return;
      }

      var x = vp.scrollLeft;
      var mx = maxScroll();
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= mx - 1;

      if (status) {
        var rng = visibleRange();
        var total = slides.length;
        var txt = 'Showing ' + rng[0];
        if (rng[1] > rng[0]) txt += '–' + rng[1];
        txt += ' of ' + total + ' review' + (total === 1 ? '' : 's');
        status.textContent = txt;
      }
    }

    var raf = 0;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }

    function page(dir) {
      vp.scrollBy({ left: dir * vp.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }

    var onPrev = function () { page(-1); };
    var onNext = function () { page(1); };
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    vp.addEventListener('scroll', onScroll, { passive: true });

    var ro = null;
    var onResize = function () { update(); };
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(onResize);
      ro.observe(vp);
    } else {
      window.addEventListener('resize', onResize);
    }

    root._revCleanup = function () {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      vp.removeEventListener('scroll', onScroll);
      if (ro) { ro.disconnect(); } else { window.removeEventListener('resize', onResize); }
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      root.dataset.revReady = '';
      carousel.classList.remove('is-ready', 'has-nav');
    };

    update();
    // Re-measure once fonts/layout settle so the first status/disabled state is right.
    setTimeout(update, 300);
  }

  function eachRoot(scope, fn) {
    if (!scope) scope = document;
    if (scope.classList && scope.classList.contains('tpg-rev')) fn(scope);
    if (scope.querySelectorAll) {
      var nodes = scope.querySelectorAll('.tpg-rev');
      for (var i = 0; i < nodes.length; i++) fn(nodes[i]);
    }
  }

  function initAll(scope) { eachRoot(scope, setup); }
  function teardown(scope) {
    eachRoot(scope, function (el) { if (el._revCleanup) el._revCleanup(); });
  }

  if (!window.__tpgRevBound) {
    window.__tpgRevBound = true;
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
})();
